import { LoadingStatusType } from "@/enums/enums";
import { AccessToken, RefreshToken } from "@/helper/authenticationHelper";
import { GetSelectedMerchant } from "@/helper/merchantHelper";
import { UserModel } from "@/model/user/userModel";
import { ConvertToUserModel } from "@/service/authentication/authenFacade";
import UserService from "@/service/user/userService";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class Authentication extends VuexModule {
  public userModel: UserModel | null = null;
  public loginLoadingStatus = LoadingStatusType.None;
  public isAuthorized: boolean = false;
  public accessToken: string = "";
  public refreshToken: string = "";

  get getIsAuthorized(): boolean {
    return this.isAuthorized;
  }
  get getLoginLoadingStatus(): LoadingStatusType {
    return this.loginLoadingStatus;
  }
  get getUserInfo(): UserModel | null {
    return this.userModel;
  }

  @Mutation
  public MutationSetIsAuthorized(isAuthorize: boolean) {
    this.isAuthorized = isAuthorize;
  }
  @Mutation
  public MutationLoginLoadingStatus(status: LoadingStatusType): void {
    this.loginLoadingStatus = status;
  }
  @Mutation
  public MutationSetUserModel(userModel: UserModel) {
    this.userModel = userModel;
    sessionStorage.setItem("eui", userModel.userId.PeakEncryption());
  }
  @Mutation
  public MutationSetToken(token: any) {
    this.accessToken = token.accessToken;
    this.refreshToken = token.refreshToken;
  }

  @Action
  public DoGetUserInfo(merchantId: number) {
    const accessToken = AccessToken();
    const refreshToken = RefreshToken();
    if (accessToken && refreshToken && merchantId > 0) {
      this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Loading);
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      UserService.DoGetUserInfo().then((resUserInfo) => {
        if (resUserInfo.status.IsSuccess()) {
          const userModel = ConvertToUserModel(resUserInfo.data.userInfo);
          UserService.DoGetSelectedMerchant(merchantId).then((resSeletectedMerchant) => {
            if (resSeletectedMerchant && resSeletectedMerchant.status.IsSuccess() && resSeletectedMerchant.data.responseCode.IsSuccess()) {
              const selectMerchant = GetSelectedMerchant(resSeletectedMerchant.data.merchant);
              if (selectMerchant && selectMerchant.merchantId == merchantId) {
                this.context.commit("MutationSetUserModel", userModel);
                this.context.commit("MutationSetToken", { accessToken: accessToken, refreshToken: refreshToken });
                this.context.commit("MutationSetIsAuthorized", true);
              } else {
                this.context.commit("MutationSetIsAuthorized", false);
              }
            } else {
              this.context.commit("MutationSetIsAuthorized", false);
            }
            this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
          });
        } else {
          this.context.commit("MutationSetIsAuthorized", false);
          this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
        }
      });
    } else {
      this.context.commit("MutationSetIsAuthorized", false);
      this.context.commit("MutationLoginLoadingStatus", LoadingStatusType.Success);
      this.context.dispatch("Loading/IsLoading", false, { root: true });
    }
  }
}
